module.exports = __webpack_public_path__ + "static/media/417.86d29151.webp";